function getFieldValue(element, fieldInternalName) {
    var _a, _b, _c;
    return (_c = (_b = (_a = element.fields) === null || _a === void 0 ? void 0 : _a.find(function (f) { return f.id === fieldInternalName; })) === null || _b === void 0 ? void 0 : _b.value) === null || _c === void 0 ? void 0 : _c.toString();
}

export { getFieldValue };
//# sourceMappingURL=getFieldValue.js.map
